import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import dayjs from "@gtmhub/dayjs";
import { DEFAULT_CADENCE_DURATION_IN_DAYS } from "@webapp/reflections/models/reflections.models";

@Component({
  selector: "cadence-label",
  templateUrl: "./cadence-label.component.html",
  styleUrls: ["./cadence-label.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadenceLabelComponent implements OnInit {
  @Input() public cadenceStartDate: string;

  public dateRange: string;

  public ngOnInit(): void {
    this.setCadenceDates();
  }

  private setCadenceDates(): void {
    const formattedStartDate = dayjs(this.cadenceStartDate).format("MMM D");
    const formattedEndDate = dayjs(this.cadenceStartDate).utc().add(DEFAULT_CADENCE_DURATION_IN_DAYS, "day").format("MMM D");

    this.dateRange = `${formattedStartDate} - ${formattedEndDate}`;
  }
}
